



import { StoreThunkAction } from 'store/state'

import { LEGACY_URL } from 'config'
import { firstValueFrom } from 'rxjs'
import { ajax } from 'rxjs/ajax'
import toCamelCase from 'utils/toCamelCase'

export const ERROR_NO_EMAIL_RETURNED = 'ERROR_NO_EMAIL_RETURNED'
const HTTP_FAILURE_CODE_START = 400

export function getLegacyCredentials(token: string, params?: Partial<Record<string, string>>): StoreThunkAction<Promise<any>> {
  return () => {
    return firstValueFrom(ajax({
      url: LEGACY_URL + `/login/test_fb_token?access_token=${encodeURIComponent(token)}`,
      method: 'POST',
      body: { ...params, token },
      headers: {
        Accept: 'application/vnd.postplanner.v2+json'
      },
      crossDomain: true,
      withCredentials: false
    }))
      .then((response: any) => {
        const error = response.response.error
        if (response.status === 0 || response.status >= HTTP_FAILURE_CODE_START || error) {
          const err = new Error(error?.message || 'Unknown error occurred') as Error & { code?: string, data?: any }
          err.code = error.code
          err.data = toCamelCase(error.data)
          throw err
        }

        return {
          user: toCamelCase(response.response.user),
          products: response.response.subscriptions.products,
          addons: response.response.subscriptions.addons || []
        }
      })
  }
}
